module.exports = __webpack_public_path__ + "static/media/580x400.7b882679.png";